import { Paper } from '@mui/material';
import styled, { css } from 'styled-components';
import { theme } from 'styles/mui-config';


const hasBorder = ({ type }) => {
  if (type === 'limited') {
    return css`
     border:3px solid red !important;
     box-shadow:0 0 2px red !important;
    `
  }
}
export const StyledPaper = styled(Paper)`
  display:flex;
  align-items:center;
  justify-content:space-around;
  height:90px;
  ${hasBorder}
  
`;
////////////////////////////////////////
export const StyledCountDiv = styled.div`
  width:40px;
  height:40px;
  background-color:${props => props.last_item ? theme.palette.success.light : theme.palette.primary.dark};
  
  border-radius:50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:white;
  font-size:16px;
`;